import * as React from 'react';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import { DocumentsPage } from '@/pages/documents';
import { DocumentPage } from '@/pages/documents/document';
import { RoleGuard } from '@/components/auth/guards/role-guard';
import { ACCOUNT_ROLES } from '@/constants/account-roles';
import { COMMUNITY_ROLES } from '@/constants/community-roles';

export const route: RouteObject = {
  path: paths.documents.index,
  element: (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
  children: [
    {
      index: true,
      element: (
        <RoleGuard
          requiredAccountRoles={[ACCOUNT_ROLES.ACCOUNT_ADMIN]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER]}
        >
          <DocumentsPage />
        </RoleGuard>
      ),
    },
    {
      path: `${paths.documents.index  }/d/:folderId`,
      element: (
        <RoleGuard
          requiredAccountRoles={[ACCOUNT_ROLES.ACCOUNT_ADMIN]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER]}
        >
          <DocumentPage />
        </RoleGuard>
      ),
    },
  ],
};
